<cmps-dialog>
    <div class="py-3">
        <h4>{{ _i18n._9387_BASE_BONUS_DETAIL_ | translate }}</h4>
    </div>

    <div class="container">
        <div class="row">
            <div class="col">
                <div *ngIf="_data">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <caption></caption>
                            <thead>
                                <tr>
                                    <th
                                        scope="col"
                                        colspan="6"
                                        class="text-center"
                                    >
                                        <span class="font-weight-bold">{{
                                            _i18n._9386_VARIABLE_PAY_BASE_BONUS_GRID
                                                | translate
                                        }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of _data">
                                    <td class="text-center">
                                        {{
                                            _i18n._9384_BASE_BONUS_WHEN_TOTAL_SCORE_FROM
                                                | translate
                                        }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.lowerBand }}
                                    </td>
                                    <td class="text-center">
                                        {{ _i18n._9253_TO | translate }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.upperBand || '-' }}
                                    </td>
                                    <td class="text-center">
                                        {{
                                            _i18n._9385_BASE_BONUS_VARIABLE_PAY_BASE_BONUS_IS
                                                | translate
                                        }}
                                    </td>
                                    <td class="text-center">
                                        ${{
                                            item.amount | number: '1.0-2' || '-'
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div *ngIf="!_data">
                    <div class="sc-no-data-available">
                        {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="py-3 d-flex justify-content-end">
        <button
            class="cmps-outline-button--no-bg"
            cmpsOutlineButton
            (click)="_dialogRef?.close()"
        >
            <span cmpsOutlineButtonLabel>{{
                _i18n._763_CLOSE_MODAL_ | translate
            }}</span>
        </button>
    </div>
</cmps-dialog>
